/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import NodeReferenceData from '../Utility/Component/Node/NodeReferenceData';
import Effect from './Effect';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

// tslint:disable-next-line:no-string-literal
const TweenLite: any = window["TweenLite"];

/** Tweens an animatable property on the referenced node. */
@cc._decorator.ccclass
export default class TweenEffect extends Effect
{
    /** The referenced node. */
    @property({ type: NodeReferenceData, visible: true })
    private _nodeRef: NodeReferenceData = new NodeReferenceData();

    /** The duration of the tween. */
    @property({ type: cc.Float, visible: true })
    private _duration: number = 0.0;

    /** The node property to be tweened. */
    @property({ visible: true })
    private _property: string = "";

    /** The start value of the tween. */
    @property({ type: cc.Float, visible: true })
    private _start: number = 0;

    /** Whether the property's current value should be used as the start value. */
    @property({ visible: true })
    private _startCurrent: boolean = false;

    /** The end value for the tweened property. */
    @property({ type: cc.Float, visible: true })
    private _end: number = 0;

    @property()
    protected setActive: boolean = false;

    private _originalStart: number = 0;

    /** Executes the tween on the referenced node's property. */
    protected trigger = (): void =>
    {
        let start: any = {};
        start[this._property] = this._start;

        this._originalStart = this._nodeRef.Value
            ? this._nodeRef.Value[this._property]
            : this._start;

        let end: any = {};
        end[this._property] = this._end;
        end.onComplete = () => this.complete();
        end.onCompleteScope = this;

        this.tweenProperty(start, end);
    }

    /** @hidden */
    protected start(): void
    {
        if (this.reference.InstanceID && this.reference.Value)
        {
            this._nodeRef.Node = this.reference.Value.node;
        }

        super.start();
    }

    private tweenProperty(start: any, end: any): void
    {
        if (!this._nodeRef.Value) { return; }

        if (this.setActive) { this._nodeRef.Value.active = true; }

        if (start[this._property] === end[this._property] || this._duration === 0)
        {
            this._nodeRef.Value[this._property] = end[this._property];
            this.complete();
            return;
        }

        if (this._startCurrent)
        {
            TweenLite.to(this._nodeRef.Value, this.dtModRef.Value.Reduce(this._duration), end);
        }
        else
        {
            this._nodeRef.Value[this._property] = start;
            TweenLite.fromTo(this._nodeRef.Value, this.dtModRef.Value.Reduce(this._duration), start, end);
        }
    }

    public Reset(): void
    {
        super.Reset();

        if (!this._nodeRef.Value) { return; }

        // this._nodeRef.Value[this._property] = this._originalStart;
    }

    /** @hidden */
    private onClick(): void
    {
        this.Stop();
    }

    /** Stops the in-progress effect or its next trigger. */
    public Stop(): void
    {
        super.Stop();

        this.complete();
    }
}
